import React from 'react';
import classNames from 'classnames/bind';
import {
  Button, Card, Image
} from '@thd-olt-component-react/core-ui';
import {
  params, string as stringType, shape, useDataModel
} from '@thd-nucleus/data-sources';
import { string } from 'prop-types';
import { ArticleInfoPod } from './article-info-pod';
import styles from './article-lead-generation.module.scss';

const ArticleGenLead = ({ articleGUID = '' }) => {
  const { data, loading, error } = useDataModel('article', {
    variables: {
      articleGUID
    }
  });
  let widgetData = data?.article?.Widget;
  const HOME_PAGE = 'https://www.homedepot.com/services/';

  const HOME_SERVICES_BADGE_URL = 'home-services-icon.svg';

  const cx = classNames.bind(styles);
  if (!articleGUID || !data || loading || error || !widgetData) {
    return null;
  }
  const triggerArticleLeadGenAnalyticsEvent = () => {
    window.LIFE_CYCLE_EVENT_BUS.trigger('article-lead-generation.get-a-free-consultation', { leadgen: 'lead gen' });
  };
  return (
    <Card className={cx('article-gen')}>
      <Image
        alt="home-service"
        asset={HOME_SERVICES_BADGE_URL}
        width="100"
        height="auto"
      />
      <div className={cx('article-gen__title')}>{widgetData?.title}</div>
      <div>Leave Your Next Project to Us</div>
      {widgetData?.items.length ? widgetData.items.map((article) => (
        <ArticleInfoPod key={article.title} title={article.title} articleDetails={article.description} />
      )) : null}
      <div className={cx('article-gen__btn')}>
        <Button>
          <a
            className={cx('article-gen__anchor')}
            href={widgetData?.buttonURL || HOME_PAGE}
            target="_blank"
            rel="noreferrer"
            onClick={triggerArticleLeadGenAnalyticsEvent}
          >
            {widgetData?.buttonLabel}
          </a>
        </Button>
        <Button link>
          <a
            className={cx('article-gen__anchor')}
            href={widgetData?.linkUrl || HOME_PAGE}
            target="_blank"
            rel="noreferrer"
          >
            {widgetData?.linkLabel}
          </a>
        </Button>
      </div>
    </Card>
  );
};

ArticleGenLead.dataModel = {
  article: params({
    articleGUID: stringType()
  }).shape({
    Widget: shape({
      buttonLabel: stringType(),
      buttonURL: stringType(),
      description: stringType(),
      linkLabel: stringType(),
      linkUrl: stringType(),
      title: stringType(),
      items: shape({
        description: stringType(),
        endDate: stringType(),
        extraContent: stringType(),
        iconName: stringType(),
        readMoreLinkText: stringType(),
        title: stringType()
      })
    })
  })
};
ArticleGenLead.displayName = 'ArticleGenLead';
ArticleGenLead.propTypes = {
  articleGUID: string.isRequired,
};
export { ArticleGenLead };
